export default __webpack_public_path__ + "static/portfolio-home-0b906056aa22453edf47745a62c24951.png";